/*****
 * menu sticky
 * scroll to top
 * Menu responsive
 */

(function ($) {
  // L'action jQuery(document).ready et DOMContentLoaded garantissent que le HTML est chargé.
  document.addEventListener('DOMContentLoaded', function () {

    // Logique du Menu Sticky
    $(document).scroll(function () {
      if ($(document).scrollTop() > 0) {
        $("#Drc_nav_menu").addClass("sticky");
      } else {
        $("#Drc_nav_menu").removeClass("sticky");
      }
    });

    // --- Logique du Bouton Retour vers le Haut ---

    // 1. Récupération des éléments une seule fois pour la performance et la clarté
    const scrollTopButton = document.getElementById('Drc_scroll_top_button');
    const scrollTotopLink = document.querySelector('.Drc-scroll-totop');

    // 2. Affichage du bouton retour vers le haut au défilement de la page (Sécurisé)
    // On vérifie si l'élément 'Drc_scroll_top_button' existe avant d'ajouter le listener pour eviter les erreurs JavaScript.
    if (scrollTopButton) {
      window.addEventListener('scroll', function () {
        if (window.scrollY > 100) {
          // Si l'élément existe, la manipulation du style est sécurisée.
          scrollTopButton.style.display = 'block';
        } else {
          scrollTopButton.style.display = 'none';
        }
      });
    } else {
      console.warn("Avertissement : L'élément avec l'ID 'Drc_scroll_top_button' est introuvable. La fonctionnalité de défilement vers le haut est désactivée.");
    }

    // 3. Défiler la page vers le haut au clic (Sécurisé)
    // On vérifie si l'élément '.Drc-scroll-totop' existe avant d'ajouter l'écouteur de clic.
    if (scrollTotopLink) {
      scrollTotopLink.addEventListener('click', function (e) {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    } else {
      console.warn("Avertissement : L'élément avec la classe '.Drc-scroll-totop' est introuvable. La fonctionnalité de clic vers le haut est désactivée.");
    }

  });
})(jQuery);

// Menu responsive Burger et son animation 
(function ($) {
  // On met en cache les éléments <body> et <html> pour bloquer le scroll
  const $contentAndHTML = $('body, html');
  // On met en cache le <body> pour lui appliquer la classe de poussée
  const $body = $('body');
  const $sidebar = $('#Drc_collapse');

  $(document).ready(function () {
    $('.Drc-menu-icon').click(function (e) {
      e.preventDefault();
      var $this = $(this);

      // Bascule l'état visuel de l'icône
      $this.toggleClass('Drc-opened Drc-closed');

      // Bascule la classe du menu (ouverture/fermeture)
      $sidebar.toggleClass('Drc-left-menu');

      // NOUVEAU : Bascule la classe SCSS qui pousse le body via transform
      $body.toggleClass('Drc-content-pushed');

      // Bascule la classe no-scroll sur body et html.
      $contentAndHTML.toggleClass('no-scroll');

      // Appelle la fonction de mise à jour des propriétés CSS
      toggleMenu();
    });
  });

  function toggleMenu() {
    // La gestion de la classe Drc-content-pushed est faite dans le gestionnaire de clic,
    // donc cette fonction se concentre sur le menu lui-même.

    if ($sidebar.hasClass('Drc-left-menu')) {
      // ÉTAT OUVERT
      $sidebar.css('left', '0');
      // Les lignes $body.css('margin-left') restent commentées, remplacées par la classe Drc-content-pushed
      $sidebar.css('opacity', '1');
      //Pour que le menu prenne toute la hauteur
      $sidebar.css('height', '100%');
    } else {
      // ÉTAT FERMÉ
      $sidebar.css('left', '-18rem');
      // Les lignes $body.css('margin-left') restent commentées
      $sidebar.css('opacity', '0');
    }
  }
})(jQuery);